import { Component, Input } from "@angular/core";
import { ClubService } from "../../providers/club.service";
import { UtilService } from "../../providers/util.service";
import { BvIconComponent } from "../../design-system/primitives/icon.component";


@Component({
    selector: "app-member-avatar",
    templateUrl: "./member-avatar.component.html",
    styleUrls: ["./member-avatar.component.css"],
    imports: [BvIconComponent]
})
export class MemberAvatarComponent {
  @Input() uid!: string;
  @Input() member: any;
  @Input() name!: string;
  @Input() imgURL!: string;
  @Input() size!: number;
  // Optional individual-bounty head value — renders a small pill overlapping the
  // avatar bottom when > 0. Callers pass tournServ.individualBountyOf(player).
  @Input() bounty: number = 0;

  constructor(public clubServ: ClubService, public utilServ: UtilService) {}

  private resolveMember(): any {
    if (this.member) return this.member;
    if (this.uid && this.clubServ.latestClub?.members?.[this.uid]) {
      return this.clubServ.latestClub.members[this.uid];
    }
    return null;
  }

  get displayImg(): string {
    if (this.imgURL && this.utilServ.hasPlayerImage(this.imgURL)) return this.imgURL;
    const data = this.resolveMember();
    if (data?.imgURL && this.utilServ.hasPlayerImage(data.imgURL)) return data.imgURL;
    return "";
  }

  get initials(): string {
    const data = this.resolveMember();
    const resolvedName =
      data?.memberName || data?.dispName || data?.displayName || this.name || "";
    return this.utilServ.getInitials(resolvedName);
  }

  get resolvedSize(): number {
    return this.size || 36;
  }

  get fontSize(): number {
    return Math.round(this.resolvedSize * 0.36);
  }

  get borderWidth(): number {
    return this.resolvedSize >= 64 ? 2 : 1.5;
  }

  get hostClass(): string {
    const classes = ["member-avatar"];
    if (!this.size) classes.push("member-avatar--legacy");
    return classes.join(" ");
  }
}
